module.exports = __webpack_public_path__ + "media/images/sprite-blue-wave-a7469b39279420b67170286c1965046a.svg";